import React from "react";
import styles from "./mediaswiper.module.css";

type PropType = {
  selected: boolean;
  index: number;
  onClick: () => void;
  url: string;
};

export const Thumb: React.FC<PropType> = (props) => {
  const { selected, index, onClick, url } = props;

  return (
    <div
      className={`${styles["embla-thumbs__slide"]} ${
        selected ? styles["embla-thumbs__slide--selected"] : ""
      }`}
    >
      <button
        onClick={onClick}
        type="button"
        className={`${styles[""]}`}
      >
        <img src={url}  ></img>
      </button>

       
    </div>
    
  );
};
